import { COLORS } from "../configs/word-cloud-chart.component.config";
import { calcAutoFontSize } from "../../../../../../helpers";


export function mapDataValuesToPixels(data: number[], maxHeight: number): number[] {
  const maxCharHeight = Math.max(...data);
  const sizeRatio = maxHeight / maxCharHeight;
  const minFontSize = calcAutoFontSize();
  return data.map(value => Math.max(value * sizeRatio, minFontSize));
}

export function mapDataValueToColor(value: number, maxAvailableHeight: number): string {
  const colorStepValue = maxAvailableHeight / 10;

  switch (true) {
    case value <= colorStepValue:
      return COLORS.COLOR_1;
    case value <= colorStepValue * 2:
      return COLORS.COLOR_2;
    case value <= colorStepValue * 3:
      return COLORS.COLOR_3;
    case value <= colorStepValue * 4:
      return COLORS.COLOR_4;
    case value <= colorStepValue * 5:
      return COLORS.COLOR_5;
    case value <= colorStepValue * 6:
      return COLORS.COLOR_6;
    case value <= colorStepValue * 7:
      return COLORS.COLOR_7;
    case value <= colorStepValue * 8:
      return COLORS.COLOR_8;
    case value <= colorStepValue * 9:
      return COLORS.COLOR_9;
    case value <= colorStepValue * 10:
      return COLORS.COLOR_10;
    default:
      return COLORS.COLOR_10;
  }
}
